import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsAsync(clientId) {
        return (await Vue.http.get(`/api/ussd/settings/${clientId}`)).data;
    },
    async saveSettingsAsync(clientId, settings) {
        await Vue.http.post(`/api/ussd/settings/${clientId}`, settings);
        noty.success("Settings saved successfully");
    }
};


// WEBPACK FOOTER //
// ./src/services/ussd.service.js